import { render, staticRenderFns } from "./ManageOrdersInTable.vue?vue&type=template&id=e00cb270&scoped=true"
import script from "./ManageOrdersInTable.vue?vue&type=script&lang=js"
export * from "./ManageOrdersInTable.vue?vue&type=script&lang=js"
import style0 from "./ManageOrdersInTable.vue?vue&type=style&index=0&id=e00cb270&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e00cb270",
  null
  
)

export default component.exports